import React from 'react';
import { recordTrack } from '@saucelabs/sl-util-segmentio';

import { TESTOBJECT_FASTSWITCH_URL, APP_TESTING_WIKI_URL } from '../constants';
import * as Styles from './NoticeForOldUsers.styles';

const NoticeForOldUsers = () => (
  <div className={Styles.base}>
    <p>
      {'Looking for your old apps? Check out the '}
      <a
        href={TESTOBJECT_FASTSWITCH_URL}
        onClick={() => recordTrack('Apps on TestObject opened')}
        rel="noopener noreferrer"
        target="_blank"
      >
        old repository
      </a>
      {'.'}
    </p>
    <p>
      {'Have questions? See the '}
      <a
        href={APP_TESTING_WIKI_URL}
        rel="noopener noreferrer"
        target="_blank"
      >
        documentation
      </a>
      {'.'}
    </p>
  </div>
);

export default NoticeForOldUsers;
